<script>
export default {
  name: "popupSelect",
  components: {},
  props: {
    //是否开启搜索
    search: {
      type: Boolean,
      default: false
    },
    //搜索 过滤参数
    searchFilter: {
      type: [String, Array, Function],
      default: () => ["text", "simpleCode"]
    },
    //搜索框 提示文字
    searchPlaceholder: {
      type: String,
      default: ""
    },
    //值
    value: {
      type: Boolean,
      default: false
    },
    //数据
    options: {
      type: Array,
      default: () => []
    },
    //默认选中项索引
    defaultIndex: {
      type: Number,
      default: 0
    },
    //数据value 参数
    valueField: {
      type: String,
      default: "id"
    },
    //数据text 参数
    labelField: {
      type: String,
      default: "name"
    },
    //确认文字
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消文字
    cancelButtonText: {
      type: String,
      default: "取消"
    },
    //点击取消 是否清空数据
    isClear: {
      type: Boolean,
      default: false
    },
    //弹出时是否选中默认项 defaultIndex
    isSelectDefault: {
      type: Boolean,
      default: false
    },
    //挂载dom
    getContainer: {
      type: String,
      default: "#app"
    },
    //点击遮罩层是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      popupShow: true,
      visibleColumns: this.options,
      searchValue: ""
    };
  },
  watch: {
    options() {
      this.visibleColumns = this.options;
    },
    value(e) {
      if (this.isSelectDefault && e) {
        this.searchValue = "";
        this.popupShow = false;
        this.visibleColumns = this.options;
        this.$nextTick(() => {
          this.popupShow = true;
          this.$nextTick(() => {
            this.visible = e;
          });
        });
      } else {
        this.visible = e;
      }
    },
    visible(e) {
      this.$emit("input", e);
    }
  },
  created() {
    this.visible = this.value;
  },
  methods: {
    /**
     * @description: 确认
     * @param {*} data
     * @return {*}
     */
    confirm(data) {
      this.$emit("confirm", data);
    },
    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    cancel() {
      if (this.isClear) {
        this.confirm("");
      } else {
        this.$emit("cancel");
        this.$emit("input", false);
      }
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    onSearch() {
      let that = this;
      that.$nextTick(() => {
        let { searchValue, searchFilter, options } = that;
        if (searchValue && searchFilter) {
          if (typeof searchFilter == "string") {
            that.visibleColumns = options.filter(p => {
              return (
                p[searchFilter] &&
                p[searchFilter]
                  .toString()
                  .toLowerCase()
                  .indexOf(searchValue.toLowerCase()) > -1
              );
            });
          } else if (searchFilter instanceof Array) {
            that.visibleColumns = options.filter(p => {
              return searchFilter.find(
                o =>
                  p[o] &&
                  p[o]
                    .toString()
                    .toLowerCase()
                    .indexOf(searchValue.toLowerCase()) > -1
              );
            });
          } else {
            that.visibleColumns = options.filter(p => searchFilter(p));
          }
        } else {
          that.visibleColumns = options;
        }
      });
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    popupRender() {
      if (!this.popupShow) return;
      const option = {
        props: {
          position: "bottom",
          value: this.visible,
          getContainer: this.getContainer,
          closeOnClickOverlay: this.closeOnClickOverlay
        },
        on: {
          input: e => {
            this.visible = e;
          }
        }
      };
      return <van-popup {...option}>{this.pickerRender()}</van-popup>;
    },
    /**
     * @description: 搜索 渲染
     * @param {*}
     * @return {*}
     */
    searchRender() {
      let that = this;
      if (that.search) {
        return (
          <van-search
            {...{
              props: {
                value: this.searchValue,
                placeholder: this.searchPlaceholder
              },
              on: {
                input: e => {
                  that.searchValue = e;
                  that.onSearch();
                }
              }
            }}
          />
        );
      }
    },
    /**
     * @description: 选择框 渲染
     * @param {*}
     * @return {*}
     */
    pickerRender() {
      const option = {
        props: {
          showToolbar: true,
          valueKey: this.labelField,
          columns: this.visibleColumns,
          defaultIndex: this.defaultIndex,
          cancelButtonText: this.cancelButtonText,
          confirmButtonText: this.confirmButtonText
        },
        on: {
          cancel: this.cancel,
          confirm: this.confirm
        },
        ref: "picker"
      };
      return <van-picker {...option} />;
    }
  },
  render() {
    return this.popupRender();
  }
};
</script>

<style lang="less" scoped>
.van-picker__toolbar {
  height: 44px;
}
</style>
